export const microSticker = {
    enabled: true,
    _description: 'Enables the micro sticker feature on bank card settings page.',
};
